import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import ReactTooltip from "react-tooltip";
import Button, { Help } from "./Button";
import ActionSearch from "material-ui/svg-icons/action/search";
import ReactFileReader from 'react-file-reader';
import TouchRipple from "material-ui/internal/TouchRipple";
import { checkMobile, isIpadOS } from "../../lib";

class ActionButtons extends React.Component {
  render() {
    const hint = {
      addEmail: this.props.intl.formatMessage({ id: "emailAddressBook.addEmailHint" }),
      editGroup: this.props.intl.formatMessage({ id: "emailAddressBook.editGroupHint" }),
      importCSV: this.props.intl.formatMessage({ id: "emailAddressBook.importCSVHint" }),
      exportCSV: this.props.intl.formatMessage({ id: "emailAddressBook.exportCSVHint" }),
      searchPlaceholder: this.props.intl.formatMessage({ id: "emailAddressBook.searchAddressBook" }),
    }
    return (
      <div
        style={{
          marginBottom: "6px",
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          position: 'relative'
        }}
        className="action-container"
      >
        <ReactTooltip place="top" multiline effect="solid" html />
        <div style={{
          display: "flex",
          // justifyContent: "space-between",
          flexWrap: 'wrap',
          alignItems: "center",
          position: 'relative'
        }}>
          <Button
            label={<FormattedMessage id="emailAddressBook.addNew" />}
            handleButtonClick={this.props.handleAddEmail}
            help={true}
            emailPageButtons={true}
            helpContent={hint.addEmail}
            minWidth="unset"
            className="email-page-button"
          />
          <Button
            label={<FormattedMessage id="emailAddressBook.editGroup" />}
            handleButtonClick={this.props.handleEditGroup}
            className="email-page-button"
            help={true}
            helpContent={hint.editGroup}
          />


          {!checkMobile() && !isIpadOS() && <div style={{ minWidth: '180px', maxWidth: '180px', width: '100%', position: 'relative', display: 'flex', marginRight: '16px' }} className="email-page-button">
            <ReactFileReader fileTypes={".csv"} handleFiles={this.props.handleFiles}>
              <TouchRipple>
                <button className="import-csv-button">
                  <span style={{ marginRight: '5px', textTransform: 'uppercase' }} >
                    <FormattedMessage id="emailAddressBook.csvImport" />
                  </span>
                  <Help content={hint.importCSV} isAbsolute={true} />
                  <div className="import-csv-button-backdrop"></div>
                </button>
              </TouchRipple>
            </ReactFileReader>
          </div>}

          {!checkMobile() && !isIpadOS() && <Button
            label={<FormattedMessage id="emailAddressBook.csvDownload" />}
            handleButtonClick={this.props.handleCsvExport}
            className="email-page-button"
            maxWidth="292px"
            help={true}
            helpContent={hint.exportCSV}
          />}
        </div>
        <div
          style={{
            border: "1px solid #6B7c93",
            position: "relative",
            height: "36px",
            display: "flex",
            alignItems: "center",
            maxWidth: "250px",
            minWidth: '250px',
            margin: '6px 0'
          }}
          className="email-address-book-search"
        >
          <input
            onChange={this.props.onSearch}
            className="email-search"
            placeholder={hint.searchPlaceholder}
            style={{
              border: "none",
              width: this.props.view !== 'mobile' ? '82%' : '100%',
              height: "90%",
              padding: "0 5px",
              color: "#657285"
            }}
          />
          <ActionSearch
            style={{
              position: "absolute",
              right: "0",
              marginRight: "5px",
              fill: "#6B7c93",
            }}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl(ActionButtons);



// WEBPACK FOOTER //
// src/components/EmailAddressBook/ActionButtons.js